import { Component, OnInit } from '@angular/core';
import { ToastService } from '../../../../services/toast.service';
import { ValidacaoParametro } from '../../../../types/ValidacaoParametro.type';
import { ValidacaoNotaFiscalService } from './validacao-nota-fiscal.service';

@Component({
  selector: 'app-validacao-nota-fiscal',
  templateUrl: './validacao-nota-fiscal.component.html',
  styleUrl: './validacao-nota-fiscal.component.css'
})
export class ValidacaoNotaFiscalComponent implements OnInit {

  loading: boolean = false;
  registros: ValidacaoParametro[] = [];

  constructor(
    private service: ValidacaoNotaFiscalService,
    private toastService: ToastService
  ) {}

  ngOnInit() {
    this.carregar();
  }

  carregar() {
    this.loading = true;
    this.service.getAll().subscribe({
      next: (data) => {
        this.registros = data;
      },
      error: (error) => {
        this.loading = false;
        this.toastService.erro('Erro', 'Erro ao buscar os registros: ' + (error.error?.message || error.error));
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  alternarStatus(registro: ValidacaoParametro) {
    this.service.atualizarStatus(registro.publicId, registro.ativo).subscribe({
      next: (atualizado) => {
        registro.ativo = atualizado.ativo;
        registro.dataAtualizacao = atualizado.dataAtualizacao;
        registro.atualizadoPor = atualizado.atualizadoPor;
        this.toastService.sucesso('Status', `Validação ${atualizado.ativo ? 'ativada' : 'desativada'} com sucesso.`);
      },
      error: (error) => {
        registro.ativo = !registro.ativo;
        this.toastService.erro('Erro', 'Erro ao alternar status: ' + (error.error?.message || error.error));
      }
    });
  }
}
